import React from 'react';
import Text from '@sats-group/fresh-fitness-ui-lib/react/text';

import ContentBlocks from 'root/client/components/content-blocks/content-blocks';
import ContentContainer from 'root/client/components/content-container/content-container';
import Hero from 'root/client/components/hero/hero';
import Layout from 'root/client/components/layout/layout';

import type { GroupExerciseMainPage as Props } from './group-exercise-main-page.types';

const GroupExerciseMainPage: React.FunctionComponent<Props> = ({
  blocks,
  title,
  hero,
  layout,
}) => (
  <Layout {...layout}>
    <div className="group-exercise-main-page">
      {hero ? (
        <Hero {...hero} short />
      ) : (
        <ContentContainer className="group-exercise-main-page__title">
          <Text
            size={Text.sizes.header2}
            variant={Text.variants.hero}
            elementName="h1"
          >
            {title}
          </Text>
        </ContentContainer>
      )}
      <div className="group-exercise-main-page__content">
        <ContentBlocks {...blocks} />
      </div>
    </div>
  </Layout>
);

export default GroupExerciseMainPage;
